import React, { useState, useEffect } from 'react';
import Immutable from 'immutable';
import { Editor, EditorState, RichUtils } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import Toolbar from './Toolbar.js';
import FieldErrorText from '../FieldErrorText/FieldErrorText';

let validationClassName = '';

const UL_WRAP = <ul className="public-DraftStyleDefault-unorderedListItem" />;
const OL_WRAP = <ol />;

const blockRenderMap = Immutable.Map({
  unstyled: {
    element: 'p',
    aliasedElements: ['pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  }
});

let options = {
  inlineStyles: {
    BOLD: { element: 'b' },
    ITALIC: { element: 'i' }
  }
};

const PtpRichTextEditor = ({
  callbackHTML,
  placeholder,
  jobDescriptionHTML,
  readOnly,
  setJobDescriptionDirty,
  errorText,
  showError,
  jobDescriptionDirty,
  testId
}) => {

  const [editorState, setEditorState] = useState((jobDescriptionHTML && readOnly) ? EditorState.createWithContent(stateFromHTML(jobDescriptionHTML?.replace(/<\/p>(<br>)?/g, '</p>'))) : EditorState.createEmpty());

  useEffect(() => {
    validationClassName = '';

    if ((jobDescriptionHTML && !jobDescriptionDirty) || readOnly) {
      let modJobDescription = jobDescriptionHTML?.replace(/<\/p>(<br>)?/g, '</p>');
      const contentState = stateFromHTML(modJobDescription);
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [jobDescriptionHTML]);

  function onBlur() {
    let currentHTML = stateToHTML(editorState.getCurrentContent(), options);
    setJobDescriptionDirty(currentHTML !== '<p><br></p>');

    if (currentHTML !== '<p><br></p>') {
      validationClassName = 'text-editor__valid';
    } else if (jobDescriptionDirty) {
      validationClassName = 'text-editor__error';
    }
  }

  function onFocus() {
    validationClassName = '';
    setJobDescriptionDirty(true);
  }

  function handleKeyCommand(command, newEditorState) {
    const newState = RichUtils.handleKeyCommand(newEditorState, command);

    if (newState) {
      setEditorState(newState);
      return 'handled';
    }
    return 'not-handled';
  }

  function handleStateChange(value) {
    setEditorState(value);
    let currentHTML = stateToHTML(value.getCurrentContent(), options);
    callbackHTML(currentHTML);
  }

  const editClassName = readOnly ? 'text-editor__readOnly' : 'text-editor__editable';

  return (
    <div
      className="text-editor__root"
      onBlur={onBlur}
      onFocus={onFocus}
      data-testid={testId}
    >
      <div className={`${editClassName} ${showError ? 'text-editor__error' : validationClassName}`}>
        <Editor
          placeholder={placeholder}
          editorState={editorState}
          handleKeyCommand={handleKeyCommand}
          onChange={handleStateChange}
          readOnly={readOnly}
          testId={testId}
          blockRenderMap={blockRenderMap}
        />
        <Toolbar
          editorState={editorState}
          setEditorState={setEditorState}
        />
      </div>
      {(validationClassName === 'text-editor__error' || showError) && <FieldErrorText hidden={false}>{errorText}</FieldErrorText>}
    </div>
  );
};

export default PtpRichTextEditor;
